import React from 'react'
import classNames from 'classnames'
import { ErrorMessage } from '../error_message'
import { FormGroupProps } from './types'
import { FormValues } from 'donate/types'
import { GetErrorArguments } from 'shared/components/form_group/types'

export const FormGroup = ({ children, field, form, ...props }: FormGroupProps) => {
  const groupClass = `donate-form-group-${field.name.replace('_', '-')}`
  const inputProps = {
    ...field,
    ...props,
  } as HTMLProps<HTMLInputElement, typeof props & typeof field>
  return (
    <div className={classNames('form-group', { 'form-group-invalid': !!fieldError({ field, form }) }, groupClass)}>
      <label className="control-label sr-only" htmlFor={field.name}>
        {props.placeholder}
      </label>
      {children || <input id={field.name} className="form-control" type="text" {...inputProps} />}
      <ErrorMessage field={field.name as keyof FormValues} />
    </div>
  )
}

const fieldError = ({ field, form }: GetErrorArguments) => form.touched[field.name] && form.errors[field.name]
